import * as React from 'react'
import { useEffect } from 'react'
import { usePopoverActions } from '../../hooks'
import { LocationsPopoverProps } from '../../typings'

import Popover, { PopoverOrigin } from '@mui/material/Popover'
import Fade from '@mui/material/Fade'
import { LocationsPopoverContentSelector } from './LocationsPopoverContentSelector'

export const LocationsPopover: React.FC<LocationsPopoverProps> = (props) => {
  const { anchorEl, open, onClose } = props

  const popoverActions = usePopoverActions()
  const { popoverActionsRef, updatePosition } = popoverActions

  const popoverId = open ? 'contacts-popover' : undefined

  // Listen for custom event to close all popovers
  useEffect(() => {
    const handleCloseAll = () => {
      if (open) {
        onClose()
      }
    }

    window.addEventListener('closeAllPopovers', handleCloseAll)
    return () => {
      window.removeEventListener('closeAllPopovers', handleCloseAll)
    }
  }, [open, onClose])

  const transformOrigin: PopoverOrigin =
    props.buttonStyle === 'text'
      ? { vertical: 10, horizontal: 10 }
      : { vertical: -40, horizontal: 0 }

  return (
    <Popover
      id={popoverId}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={transformOrigin}
      elevation={3}
      action={popoverActionsRef}
      TransitionComponent={Fade}
      TransitionProps={{
        onEntered: updatePosition,
      }}
    >
      <LocationsPopoverContentSelector {...props} {...popoverActions} />
    </Popover>
  )
}
LocationsPopover.displayName = 'LocationsPopover'
